import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm font-rubik" style={{ color: '#2b6777' }}>
              © 2025 Terminfixer. Alle Rechte vorbehalten.
            </p>
            <p className="text-sm mt-2 md:mt-0 font-rubik" style={{ color: '#2b6777' }}>
              Entwickelt mit React & Tailwind CSS
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;